import React, { useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import "./index.css";
import { Modal } from "react-bootstrap";
const PrecountingModal = (props) => {
  // const [showModal, setShowModal] = useState(false);
  // const handleOpenModal = () => setShowModal(true);
  // const handleCloseModal = () => setShowModal(false);
  return (
    <div className="precounting-Modal">
      {" "}
      <div>
        {/* <button onClick={handleOpenModal}>Open Modal</button> */}
        {/* {showModal && ( */}
        <div className=" box my-4">
          <div className="ml-4 mt-1">
            {/* <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"></input> */}
          </div>
          <div className=" line1 ml-3"><b>Kindly read it carefully</b></div>
          <div className="line1 ml-3 mt-4">
           <b> Scanned QR Code is matching with the previously scanned Code.</b>
          </div>
          <div className="line1 ml-3 mt-2">
            {" "}
           <b> Are you scanning the just scanned Form 13-C ?</b>
          </div>
          <div className="clickYes "> Click "Yes" to continue....</div>{" "}
          <div className="clickYes1">
            (incase if you are scanning the <br></br>immediately scanned Form
            13-C)
          </div>
          {/* <p className='clickYes1'> (incase if you are scanning the <br></br> immediately scanned Form 13-c)</p> */}
          <div className=" OR ">OR</div>{" "}
          <div className=" clickNo">
            {" "}
            Click "NO" will mark it as Duplication...{" "}
          </div>
          <div className="clickNo1">
            (in case if you are not scanning the <br></br>immediately Scanned
            Form 13-C)
          </div>
          {/* <div>(in case if you are not scanning the immediately Scanned From 12-C)</div> */}
          <Button className=" buttonYes mt-3 " onClick={props.yesOption}>
            Yes
          </Button>
          <Button className=" buttonNo mt-3" onClick={props.noOption}>
            No
          </Button>
          {/* <button onClick={handleCloseModal}>Close Modal</button> */}
        </div>
        {/* )} */}
      </div>
    </div>
  );
};
export default PrecountingModal;
